uniform sampler2D tDiffuse;
uniform float colorTransition;
uniform vec2 mousePos;
uniform float focused;
uniform float transitionProgress;
uniform vec2 resolution;
varying vec2 vUv;

float createRoundedMask(vec2 uv, vec2 dimensions, float cornerRadius) {
    vec2 aspectRatio = dimensions.x > dimensions.y 
        ? vec2(1.0, dimensions.y/dimensions.x) 
        : vec2(dimensions.x/dimensions.y, 1.0);
    
    vec2 normalizedCoords = (uv - 0.5) * 2.0 * aspectRatio;
    vec2 distanceToEdge = abs(normalizedCoords) - aspectRatio + cornerRadius;
    
    return length(max(distanceToEdge, 0.0)) + min(max(distanceToEdge.x, distanceToEdge.y), 0.0) - cornerRadius;
}

void main() {
    vec2 mirroredUv = vec2(1.0 - vUv.x, vUv.y);
    vec4 sourceColor = texture2D(tDiffuse, mirroredUv);
    vec3 outputColor;

    if (focused > 0.5) {
        outputColor = sourceColor.rgb;
    } else {
        float luminance = dot(sourceColor.rgb, vec3(0.299, 0.587, 0.114));
        vec3 desaturatedColor = vec3(luminance);
        desaturatedColor = pow(desaturatedColor, vec3(1.1));
        
        float colorMix = smoothstep(0.0, 1.0, colorTransition);
        outputColor = mix(desaturatedColor, sourceColor.rgb, colorMix);
    }
    
    // Utilisation de la même approche que le shader vidéo pour les coins arrondis
    float cornerRadius = 0.1; // Ajustez cette valeur pour plus ou moins d'arrondi
    float roundedMask = createRoundedMask(mirroredUv, resolution, cornerRadius);
    float maskAlpha = 1.0 - step(-0.0001, roundedMask);
    
    gl_FragColor = vec4(outputColor, maskAlpha * sourceColor.a);
} 